import { Header, flexRender } from '@tanstack/react-table';
import * as React from 'react';

import styles from '../Table.module.scss';

type TableFooterProps<T> = {
  footer: Header<T, unknown>;
};

function TableFooter<T>({ footer }: TableFooterProps<T>) {
  return (
    <th key={footer.id} className={styles.footerCol}>
      {footer.isPlaceholder
        ? null
        : flexRender(footer.column.columnDef.footer, footer.getContext())}
    </th>
  );
}

export { TableFooter };
